
import { DriftAnalytics } from '@driftt/dds.analytics'

export const captureExceptionWithMessage = (message: string, error?: any, additionalData?: any) => {
  DriftAnalytics.captureException(new Error(message), {
    extra: {
      error: error,
      ...additionalData
    }
  })
}
